import {clsx as cx} from '@local/utils'
import {PortableText as SanityPortableText, toPlainText} from '@portabletext/react'
import {ElementType, createElement, forwardRef} from 'react'
import {Button} from '../button/Button'
import {Tooltip} from '../tooltip/Tooltip'
// import {slugify} from '@local/utils/string'
import {SanityImage} from '../sanityImage/SanityImage'

export interface PortableTextProps {
	className?: string
	noDom?: boolean
	blocks: any[],
	styles?: string
	as?: ElementType
}

export const normalStyle = 'text-14 lg:text-12'
export const hToStyle = {
	h2: 'text-12 leading-snug tracking-tight',
}

const Block = ({noDom = false, overriddenStyles = {}}) => {
	const BlockCurry = (props) => {
		const {style = 'normal'} = props.node

		if (noDom) {
			return props.children
		} else if (/^h\d/.test(style)) {
			// headings
			return createElement(style, {
				// id: slugify(props.node.children[0].text), // Use for anchors
				className: overriddenStyles[style] || cx(hToStyle[style]),
			}, props.children)
		} else if (style === 'blockquote') {
			// blockquotes
			return <blockquote className={cx('text-26 lg:text-30 leading-[1.1] tracking-tight', overriddenStyles.blockquote)}>{props.children}</blockquote>
		} else if (style === 'normal') {
			return <div className={cx('')}>{props.children}</div>
		} else if (style === 'subtitle') {
			return <p className={overriddenStyles.subtitle}>{props.children}</p>
		}
	}

	return BlockCurry
}

const ImageAlt = ({value}) => {
	return <SanityImage className='my-40' image={value} alt={value.alt} mobileWidth={398} desktopWidth={810} />
}

const serializers = (options = {}) => ({
	block: Block({noDom: options.noDom, overriddenStyles: options.styles}),
	types: {
		imageBlock: ImageAlt,
	},
	marks: {
		annotationDefinition: ({children, value}) => {
			return (
				<Tooltip place={value.position} content={value.definitionn}>{children}</Tooltip>
			)
		},
		link: ({children, value}) => {
			// internal link
			if (value.href?.selectedTab === 'internalLink') {
				return (
					<Button link={value} variant='classicUnderlined'>
						{children}
					</Button>
				)
			} else {
				// external links
				return (
					<Button href={value?.url} variant='classicUnderlined'>
						{children}
					</Button>
				)
			}
		},
	},
})

const CustomPortableText = ({as = 'div', blocks, noDom, styles, className}: PortableTextProps, ref) => {
	if (!blocks) return null
	const Tag = as
	const components = serializers({noDom, styles})

	return (
		<Tag ref={ref} className={cx('', className)}>
			<SanityPortableText
				value={blocks}
				components={components} />
		</Tag>
	)
}

export const PortableText = forwardRef(CustomPortableText)

interface ReadingTimeProps {
	blocks: any[],
}

export const portableTextReadingTime = ({blocks}: ReadingTimeProps) => {
	const wordsPerMinute = 225
	const plainText = toPlainText(blocks)
	const characterCount = plainText.length
	const wordCount = plainText.trim().split(/\s+/).length
	const readingTime = Math.ceil((wordCount / wordsPerMinute))

	return readingTime
}
